/**
 * Step gating + section navigation for the guided-tour engine.
 *
 * A step is visible only when its feature gate passes — the same
 * `isFeatureHidden` predicate the sidebar uses to drop nav items — so the
 * tour never highlights a surface the build has hidden. A whole hidden
 * section (e.g. Ads) filters out up front instead of relying on several
 * consecutive TARGET_NOT_FOUND auto-advances.
 */
import { isFeatureHidden } from '@/config/features'
import type { TourDefinition, TourStep } from './types'

/** The steps of a tour that are visible in this build, in order. */
export function visibleSteps(tour: TourDefinition): TourStep[] {
  return tour.steps.filter((step) => !step.featureKey || !isFeatureHidden(step.featureKey))
}

/**
 * Index of the first step belonging to the NEXT section after `fromIndex`,
 * or `-1` when there is no later section. Backs the tooltip's
 * "Skip section" control.
 */
export function nextSectionIndex(steps: TourStep[], fromIndex: number): number {
  const current = steps[fromIndex]
  if (!current) return -1
  for (let i = fromIndex + 1; i < steps.length; i += 1) {
    if (steps[i].section !== current.section) return i
  }
  return -1
}
